import React from "react";

import Textarea from "../Textarea";

export default class NoteTextarea extends React.Component {
  handleChange = (value) => {
    const escapedValue = value.replaceAll("\n", "<br>");
    this.props.onUpdate(escapedValue);
  };

  render() {
    const { value } = this.props;
    const unescapedValue = value.replaceAll("<br>", "\n");
    return (
      <Textarea
        value={unescapedValue}
        onUpdate={this.handleChange}
        style={style}
      />
    );
  }
}

const style = {
  width: "100%",
  border: "none",
  background: "transparent",
  outline: "none",
  fontSize: "18px",
  fontFamily: '"Helvetica Neue", Arial, sans-serif',
  resize: "none",
};
